<p-card>
    <div class="property-address-container">
        <h2 class="title">¿Dónde está tu {{ propertyName?.toLowerCase() }}?</h2>
        <p class="subtitle">
            Ingresa la dirección de la propiedad exactamente como viene en el Registro de Propiedad
        </p>
        <!-- Formulario de Dirección -->
        <div [formGroup]="addressForm" class="form-container">
            <div class="p-fluid grid form-grid">
                <!-- País / Región (Deshabilitado) -->
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <p-dropdown optionLabel="label" optionValue="value" [disabled]="true"
                                placeholder="Bolivia"></p-dropdown>
                </div>
                <!-- Departamento y Ciudad -->
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <p-dropdown [options]="departments" formControlName="department" optionLabel="label"
                                [showClear]="true"
                                optionValue="value" placeholder="Departamento" (onChange)="onDepartmentChange($event)">
                    </p-dropdown>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['department'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['department'], 'departamento')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['department'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <p-dropdown [options]="city" formControlName="city" optionLabel="label" optionValue="value"
                                [showClear]="true"
                                [disabled]="loadCityList" placeholder="Ciudad" (onChange)="onCityChange($event)">
                    </p-dropdown>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['city'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['city'], 'ciudad')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['city'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <p-dropdown [options]="neighborhood" formControlName="neighborhood" optionLabel="label"
                                optionValue="value" [disabled]="!loadNeighborhoodList" placeholder="Barrio/Zona"
                                [filter]="true"
                                filterBy="label"
                                [showClear]="true"
                                (onChange)="selectNeighborhoods($event)">
                    </p-dropdown>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['neighborhood'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['neighborhood'], 'zona')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['neighborhood'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Calle y Número Exterior -->
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper"
                         [class.focused]="isFocused['propertyAddress'] || this.addressForm.get('propertyAddress')?.value">
                        <label for="propertyAddress">Calle*</label>
                        <input
                            formControlName="propertyAddress"
                            pInputTextarea
                            id="propertyAddress"
                            (focus)="handleFocus('propertyAddress')"
                            (blur)="handleBlur('propertyAddress')"
                            rows="1"/>
                    </div>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['propertyAddress'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['propertyAddress'], 'calle')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['propertyAddress'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper"
                         [class.focused]="isFocused['externalNumber'] || this.addressForm.get('externalNumber')?.value">
                        <label for="externalNumber">Número exterior</label>
                        <input
                            formControlName="externalNumber"
                            pInputTextarea
                            id="externalNumber"
                            (focus)="handleFocus('externalNumber')"
                            (blur)="handleBlur('externalNumber')"
                            rows="1"/>
                    </div>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['externalNumber'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['externalNumber'], 'Número exterior')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['externalNumber'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Número Interior y Referencia -->
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper"
                         [class.focused]="isFocused['internalNumber'] || this.addressForm.get('internalNumber')?.value">
                        <label for="internalNumber">Número Interior (si aplica)</label>
                        <input
                            formControlName="internalNumber"
                            pInputTextarea
                            id="internalNumber"
                            (focus)="handleFocus('internalNumber')"
                            (blur)="handleBlur('internalNumber')"
                            rows="1"/>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper"
                         [class.focused]="isFocused['catastralCode'] || this.addressForm.get('catastralCode')?.value">
                        <label for="catastralCode">Número catastral*</label>
                        <input
                            formControlName="catastralCode"
                            pInputTextarea
                            id="catastralCode"
                            (focus)="handleFocus('catastralCode')"
                            (blur)="handleBlur('catastralCode')"
                            rows="4"/>
                    </div>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['catastralCode'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['catastralCode'], 'Número catastral')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['catastralCode'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper"
                         [class.focused]="isFocused['propertyNumber'] || this.addressForm.get('propertyNumber')?.value">
                        <label for="propertyNumber">Número de Registro de Propiedad*</label>
                        <input
                            formControlName="propertyNumber"
                            pInputTextarea
                            id="propertyNumber"
                            (focus)="handleFocus('propertyNumber')"
                            (blur)="handleBlur('propertyNumber')"
                            rows="4"/>
                        <!-- Ícono con tooltip -->
                        <span
                            class="icon-tooltip"
                            pTooltip="Ingrese el número tal como aparece en el Registro de Propiedad"
                            tooltipPosition="right">
                            <i class="pi pi-question-circle"></i>
                        </span>
                    </div>
                    <div class="error-message">
                        <ul
                            class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['propertyNumber'].dirty"
                        >
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['propertyNumber'], 'Número de registro de propiedad')">
                                <p-message severity="error" [text]="error" *ngIf="!addressForm.controls['propertyNumber'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 lg:col-6 md:col-6 sm:col-12 form-item">
                    <div class="form-control-wrapper" [class.focused]="true">
                        <label for="propertyName">Nombre de la propiedad</label>
                        <input
                            id="propertyName"
                            pInputTextarea
                            value="{{propertyNickname}}"
                            (focus)="handleFocus('propertyNickname')"
                            (blur)="handleBlur('propertyNickname')"
                            [disabled]="true"
                            rows="4"/>
                    </div>
                </div>
                <div class="col-12 lg:col-12 md:col-12 sm:col-12 form-item">
                    <div class="form-control-wrapper" [class.focused]="isFocused['locationReference'] || this.addressForm.get('locationReference')?.value">
                        <label for="locationReference">Referencia</label>
                        <input
                            formControlName="locationReference"
                            pInputTextarea
                            id="locationReference"
                            placeholder="Referencia"
                            (focus)="handleFocus('locationReference')"
                            (blur)="handleBlur('locationReference')"
                            rows="2"/>
                    </div>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled"
                            style="list-style: none; padding: 0; margin: 0; margin-top: 0px"
                            *ngIf="isNotDataValid || addressForm.controls['locationReference'].dirty">
                            <li *ngFor="let error of getValidationMessages(addressForm.controls['locationReference'], 'Referencia')">
                                <p-message severity="error" [text]="error"
                                           *ngIf="!addressForm.controls['locationReference'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Mensaje de error del servicio -->
        <div class="error-message">
            <div class="error-message">
                <ul class="text-danger list-unstyled"
                    style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                    *ngIf="showErrorDialog">
                    <li>
                        <p-message severity="error" [text]="dialogCode +' '+ dialogMessage" *ngIf="showErrorDialog"></p-message>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <app-page-navigation-bar
        [value]="20"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="mode"
        [stepKey]="'address'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</p-card>
